import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const RemoveMemberModal = ({ isOpen, onClose, member, onConfirm, loading }) => {
  const [reason, setReason] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [removedOn, setRemovedOn] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    member.reason = reason;
    member.removedOn = removedOn;
    if (confirmText.toLowerCase() === 'remove') {
      onConfirm(member, reason);
    }
  };

  const handleClose = () => {
    setReason('');
    setConfirmText('');
    onClose();
  };

  if (!isOpen || !member) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg border border-border shadow-spiritual-md max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
              <Icon name="UserX" size={20} className="text-error" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-foreground">
                Remove Member From Service
              </h2>
              <p className="text-sm text-muted-foreground">
                This action cannot be undone
              </p>
            </div>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            disabled={loading}
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4 pt-0">
          {/* Member Info */}
          <div className="bg-muted/30 rounded-lg p-4 pl-0">
            <h3 className="font-heading font-medium text-foreground mb-3 flex items-center space-x-2">
              <Icon name="User" size={18} className="text-primary" />
              <span>Member Information</span>
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
              <div>
                <span className="text-muted-foreground">Name:</span>
                <p className="font-medium text-foreground">{member.name}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Mobile:</span>
                <p className="font-mono text-foreground">{member.mobNo}</p>
              </div>
              <div>
                <span className="text-muted-foreground">District:</span>
                <p className="text-foreground">{member.district}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Samithi:</span>
                <p className="text-foreground">{member.samithi}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Sai Connect Id:</span>
                <p className="text-foreground">{member.saiOneId}</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="col-span-1">
              {/* Reason Input */}
              <Input
                  label="Removed On"
                  type="date"
                  value={removedOn}
                  onChange={(e) => setRemovedOn(e.target.value)}
                  error=''
                  required
                />
            </div>
            <div className="col-span-2">
               <Input
                  label="Reason for Removal"
                  type="text"
                  placeholder="Please provide a reason for removing this member from the system"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  required
                />
            </div>
          
               
          </div>
          {/* Confirmation Input */}
          <Input
            label="Confirmation"
            type="text"
            placeholder="Type 'REMOVE' to confirm"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            required
            description="Type 'REMOVE' to confirm this action"
          />



          {/* Warning Message */}
          <div className="bg-error/5 border border-error/20 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="AlertTriangle" size={20} className="text-error flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-heading font-medium text-error mb-1">
                  Warning: Permanent Removal
                </h4>
                <p className="text-sm text-error/80">
                  This member will be removed from the current service.The history for the current service will be deleted. This action cannot be undone.
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex space-x-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              disabled={loading}
              fullWidth
            >
              Cancel
            </Button>
            
            <Button
              type="submit"
              variant="destructive"
              loading={loading}
              disabled={!reason.trim() || confirmText.toLowerCase() !== 'remove'}
              iconName="Trash2"
              iconPosition="left"
              fullWidth
            >
              Remove Member
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RemoveMemberModal; 